
// src/actions/group-settings.js

export const OPEN_GROUP_SETTINGS_PAGE = "OPEN_GROUP_SETTINGS_PAGE"

export function openGroupSettingsPage(name) {
  return {
    type: OPEN_GROUP_SETTINGS_PAGE,
    name
  }
}

export const CLOSE_GROUP_SETTINGS_PAGE = "CLOSE_GROUP_SETTINGS_PAGE"

export function closeGroupSettingsPage() {
  return {
    type: CLOSE_GROUP_SETTINGS_PAGE,
  }
}



// WEBPACK FOOTER //
// ./src/actions/group-settings.js